import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { validateSortKey } from '../internal/helpers';
import { Head } from '../styled/TableHead';
import RankableHeadCell from './rankable/TableHeadCell';
import HeadCell from './TableHeadCell';

class TableHead extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "canSortOnEnterPressed", (e, isSortable) => isSortable && e.key === 'Enter');
  }

  UNSAFE_componentWillMount() {
    validateSortKey(this.props.sortKey, this.props.head);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) {
      validateSortKey(nextProps.sortKey, nextProps.head);
    }
  }

  render() {
    const {
      head,
      sortKey,
      sortOrder,
      isFixedSize,
      onSort,
      isRanking,
      isRankable,
      testId
    } = this.props;

    if (!head) {
      return null;
    }

    const HeadCellComponent = isRankable ? RankableHeadCell : HeadCell;
    const {
      cells,
      ...rest
    } = head;
    return /*#__PURE__*/React.createElement(Head, _extends({}, rest, {
      isRanking: isRanking,
      "data-testid": testId && `${testId}--head`
    }), /*#__PURE__*/React.createElement("tr", null, cells.map((cell, index) => {
      const {
        isSortable,
        key,
        ...restCellProps
      } = cell;
      return /*#__PURE__*/React.createElement(HeadCellComponent, _extends({
        isFixedSize: isFixedSize,
        isSortable: !!isSortable,
        isRanking: isRanking,
        key: key || index,
        onClick: isSortable ? onSort(cell) : undefined,
        onKeyDown: e => this.canSortOnEnterPressed(e, isSortable) ? onSort(cell)() : undefined,
        testId: testId,
        sortOrder: key === sortKey ? sortOrder : undefined
      }, restCellProps));
    })));
  }

}

export default TableHead;